import { z } from "zod";
export var DmaAmountUnit;
(function (DmaAmountUnit) {
    DmaAmountUnit["Kilogram"] = "Kilogram";
    DmaAmountUnit["Gram"] = "Gram";
    DmaAmountUnit["Milligram"] = "Milligram";
    DmaAmountUnit["Mole"] = "Mole";
    DmaAmountUnit["Millimole"] = "Millimole";
    DmaAmountUnit["WeightPercentage"] = "WeightPercentage";
})(DmaAmountUnit || (DmaAmountUnit = {}));
export const dmaAmountUnitDtoSchema = z.nativeEnum(DmaAmountUnit);
